import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Stack, Typography } from "@mui/material";
import { azzeraMonitoraggio } from "../../../modules/tracking";
import { PATH_HOME } from "../../../path";
import { BACK_HOME } from "../../../modules/language";
import { getMessageString } from "../../../utility";
import { PSTrackerBiancoIcon } from "../../../styles/images";

export const ModaleEventiMonitoraggio = injectIntl(({ intl, modalOpen, id, text }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <Typography sx={{ opacity: 0 }} id={"monitoraggioDialog_" + id}>
        Modale eventi speciali monitoraggio
      </Typography>
      <Dialog open={modalOpen} className="monitoraggioAlert" aria-labelledby={"monitoraggioDialog_" + id}>
        <Stack className="logoApp">
          <PSTrackerBiancoIcon />
        </Stack>
        <DialogContent>
          {text.map((testo, index) => (
            <DialogContentText key={index}>{testo}</DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(azzeraMonitoraggio());
              navigate(PATH_HOME);
            }}
          >
            {getMessageString(intl, BACK_HOME)}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});
